import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { queryKeys } from '@utils/consts';
import { ApiError } from '@root/globalTypes';
import { PanelDropdownRespSuccess } from '../types';
import { useQueryParams } from '@hooks/queryParams';
import { useParams } from 'react-router';
import { usePanel } from '@hooks/usePanel';

export const usePanelSpecialtiesDropdown = () => {
  const { tenantId } = useParams();
  const { parseParams } = useQueryParams();
  const { panel } = usePanel();

  const queryParams = parseParams({ tenantId });

  const { data, error, isPending } = useQuery<PanelDropdownRespSuccess, ApiError>({
    queryKey: [...queryKeys.dropdowns.panel.specialties, queryParams],
    queryFn: () => queryFetch({ url: `dropdowns/field_users_specialties${queryParams}`, panel }),
    placeholderData: (previousData) => previousData as PanelDropdownRespSuccess,
    enabled: Boolean(panel && tenantId),
    retry: 2,
  });

  return {
    data,
    error,
    isLoading: isPending && Boolean(panel && tenantId),
  };
};
